// extracted by mini-css-extract-plugin
export var button = "_bx-4";
export var hasDarkBackground = "_bx-7";
export var hasLightBackground = "_bx-6";
export var iconWrapper = "_bx-0";
export var large = "_bx-2";
export var medium = "_bx-1";
export var small = "_bx-5";
export var xsmall = "_bx-3";